export const getModalReducer = (state) => state.modal;
export const getModalVisible = (state) => getModalReducer(state).visible;
